<div class="container-fluid">

    <div class="row mt-10">
        <div class="col-md-6 title">Unit</div>
        <div class="col-md-6">{{Instruction.units}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Issued From</div>
        <div class="col-md-6">{{DateFormatHelper.GetDisplayDate(Instruction.issuedFrom)}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Issued To</div>
        <div class="col-md-6">{{DateFormatHelper.GetDisplayDate(Instruction.issuedTo??"")}}</div>
    </div>

    <div class="row mt-10">
        <div class="col-md-6 title">Date Comments</div>
        <div class="col-md-6">{{Instruction.dateComment}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Status</div>
        <div class="col-md-6">{{Instruction.status}}
            @if(Instruction.isArchived){
            - Archived
            }
        </div>
    </div>
    @if(Instruction.status == 'New' && UserService.getUser()?.IsTrader){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ChangeStatus('Acknowledged')">
                Acknowledge
            </nj-button>
        </div>
    </div>}

    @if(Instruction.status == 'Acknowledged' && UserService.getUser()?.IsTrader){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ChangeStatus('Completed')">
                Complete
            </nj-button>
        </div>
    </div>}
    <!-- Archive / UnArchive -->
    @if(UserService.getUser()?.CanArchive){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="ChangeStatus(Instruction.isArchived ? 'UnArchive' : 'Archive')">
                {{ Instruction.isArchived ? 'Unarchive' : 'Archive' }}
            </nj-button>
        </div>
    </div>}

    @if(Instruction.isAppliedInPPA == false){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ApplyToEDT()">
                Apply to EDT
            </nj-button>
        </div>
    </div>
    }
    @else {
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6" [style]= "'font-weight: bold; color: green;'">
            Applied to EDT
        </div>
    </div>
    }



    @if(Instruction.isRegular){
    <div class="row title mt-10 col-md-12">Regular Instruction</div>

    <div class="row mt-10">
        <div class="col-md-6 title">Strike Price</div>
        <div class="col-md-6">{{Instruction.strikePrice}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Fixed Costs</div>
        <div class="col-md-6">{{Instruction.fixedCosts}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Negative Price Trigger</div>
        <div class="col-md-6">{{Instruction.negativePriceTrigger}}</div>
    </div>

    }
    @else {

    <div class="row title mt-10 col-md-12">OverwriteInstruction</div>
    <div class="row mt-10">
        <div class="col-md-6">Relevant Settlement Periods</div>
        <div class="col-md-6">
            @for(period of RelevanPeriods; track period){
            {{period}}<br>
            }
        </div>
    </div>
    <div class="col-md-6 title row mt-10">-1 Bid Offer Pair</div>
    <div class="row mt-10">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Main Bid</div>
        </div>
        <div class="col-md-6">{{Instruction.bidOfferPairs[0].minusOne_mainBid}}</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Matching Offer</div>
        </div>
        <div class="col-md-6">{{Instruction.bidOfferPairs[0].minusOne_matchingOffer}}</div>
    </div>
    <div class="col-md-6 title row mt-10">+1 Bid Offer Pair</div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Matching Bid</div>
        </div>
        <div class="col-md-6">{{Instruction.bidOfferPairs[0].plusOne_mainBid}}</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Main Offer</div>
        </div>
        <div class="col-md-6">{{Instruction.bidOfferPairs[0].plusOne_matchingOffer}}</div>
    </div>
    }
    <div class="row title  col-md-12 mt-10">
        Comments
    </div>
    <div class=" row col-md-12 mt-10">
        {{Instruction.comments}}
    </div>

</div>